/*

Note:
1. please replace class/IDs of error message, promotion code box and discount remove button.
document.querySelector("#invalid-discount")
document.querySelector('#promotion_code')
document.querySelector(".discount-code-input")

*/

/* Add gift product to cart */

_addGiftProduct = async function(gift_data) {
    gift_data.forEach(function(gift, index) {
        if(window.cartItemsData.giftsInCart.includes(gift.id)) {
            gift_data.splice(index, 1);
            return false;
        }
    })
    var productData = {
        'items': gift_data
    };
    var result = await fetch(window.routes.cartAddUrl+'.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(productData)
    })

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

window.addProduct = async function (items) {
  return await _addGiftProduct(items)
}

/* Remove gift product from cart */

_removeGiftProduct = async function(gift_data) {
    gift_data = Object.assign({}, gift_data);

    var productData = {updates: gift_data};

    var result = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(productData)
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

window.removeProduct = async function (items) {
    return await _removeGiftProduct(items)
}

/* Clear cart */

_clearCart = async function() {
    var result = await fetch('/cart/clear.js', {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
        }
    })

    if (result.status === 200) {
        window.cart_clear = true;
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* Show/hide error message */

invalidPromotionCode = function(display) {
    var invalid_promocode = document.querySelector("#invalid-discount");

    if(invalid_promocode) invalid_promocode.style.display = display;

}

/* Add discount code */

window.addCodeStack = async function(event) {
    event.preventDefault();
    var promocode = document.querySelector('#promotion_code');
    if(window.discount.includes(promocode.value.toUpperCase())){
        await window.promotionValidate()
    } else {
        invalidPromotionCode("block");
    }
}

/* Remove discount code */

window.removeCodeStack = async function() {
    var promocode = document.querySelector('#promotion_code');
    promocode.value = "";
    localStorage.removeItem("promocode");
    await window.promotionValidate();
}

/* Clear discount box */

window.clearCodeStack = async function() {
    var promocode = document.querySelector('#promotion_code'), discountCodeInput = document.querySelector(".discount-code-input");
    localStorage.removeItem("promocode");
    if (promocode) {promocode.value = ""; promocode.removeAttribute('readonly');}
    if (discountCodeInput) discountCodeInput.classList.remove('code-applied');
    invalidPromotionCode("none");
}

/* Compare lists */

compareArrays = function (promotion = [], promotionArray = [], productCount, type = "") {
    if(promotion.operationType == "and") {
        var matched_product1 = [], matched_product2 = [];
        promotionArray.filter(x => {
            if(promotion.productList1.includes(x) && !matched_product1.includes(x)) {
                matched_product1.push(x);
            }
            if(promotion.productList2.includes(x) && !matched_product2.includes(x)) {
                matched_product2.push(x);
            }
        })
        // if both list has same product info
        // for example: if same sku is added in both list then quantity should be 2 or greater
        if (matched_product1.length == 1 && matched_product2.length == 1 && matched_product1[0] == matched_product2[0]) {
            var and_flag = false;
            window.cartItemsData.productData.filter(x => {
                if(type == "sku" && matched_product1.includes(x.sku) && x.quantity >= 2) {
                    and_flag = true;
                } else if (type == "type" && matched_product1.includes(x.type) && x.quantity >= 2) {
                    and_flag = true;
                } else if (type == "product_id" && matched_product1.includes(x.productID) && x.quantity >= 2) {
                    and_flag = true;
                } else if (type == "vendor" && matched_product1.includes(x.vendor) && x.quantity >= 2) {
                    and_flag = true;
                } else {
                    and_flag = false;
                }
            })
            if(and_flag) {
                return true;
            }
        } else if (matched_product1.length >= 1 && matched_product2.length >= 1) {
            return true;
        } else {
            return false;
        }
    } else if (type == "excludeProduct") {
        var excluded = false;
        if(promotion.minimumCartAmount || promotion.maximumCartAmount) { // price of excluded product will not count if minimum amount specified
            var cartTotal = 0, matchFound = false;
            var productData = window.cartItemsData.productData
            var cartItemTotal = window.cartItemsData.cartTotal
            productData.forEach(data => {
                var dataType = data.type
                if(promotion.excludeProduct.includes(dataType)) {
                    cartItemTotal = cartItemTotal - data.price
                    cartTotal = cartItemTotal
                    matchFound = true
                }
            })
            if(cartTotal <= 0 && !matchFound) {
                cartTotal = window.cartItemsData.cartTotal;
            }
            if(promotion.minimumCartAmount && !promotion.maximumCartAmount) {
                if(cartTotal >= promotion.minimumCartAmount) {
                    excluded = true;
                }
            } else if (!promotion.minimumCartAmount && promotion.maximumCartAmount) {
                if(cartTotal <= promotion.maximumCartAmount) {
                    excluded = true;
                    if(!promotion.conditionArray.includes("maximumCartAmount")) {
                        promotion.conditionArray.push("maximumCartAmount");
                    }
                }
            } else if(promotion.minimumCartAmount && promotion.maximumCartAmount) {
                if(cartTotal >= promotion.minimumCartAmount && cartTotal <= promotion.maximumCartAmount) {
                    excluded = true;
                    if(!promotion.conditionArray.includes("maximumCartAmount")) {
                        promotion.conditionArray.push("maximumCartAmount");
                    }
                }
            }
        } else {
            window.cartItemsData.productData.filter(x => { // Exclude product type
                if(!promotion.excludeProduct.includes(x.type)) {
                    excluded = true;
                }
            });
        }

        return excluded ? true : false;
    } else {
        var matched_product = [], quantity_count = 0;

        promotionArray.filter(x => {
            if(promotion.productList1.includes(x)) {
                matched_product.push(x);
            }
        });

        window.cartItemsData.productData.filter(x => {
            if(type == "sku" && matched_product.includes(x.sku)) {
                quantity_count = quantity_count + x.quantity;
            } else if (type == "type" && matched_product.includes(x.type)) {
                quantity_count = quantity_count + x.quantity;
            } else if (type == "product_id" && matched_product.includes(x.productID)) {
                quantity_count = quantity_count + x.quantity;
            } else if (type == "vendor" && matched_product.includes(x.vendor)) {
              quantity_count = quantity_count + x.quantity;
            }
        });

        if(quantity_count >= productCount) {
            return true;
        } else {
            return false;
        }
    }
}

/* Get product from cart */

_getCart = async function () {
    const result = await fetch(window.routes.cartUrl + '.js', {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    })

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

window.progressBar = function () {
  var gwpList = window.promotionSettings.gwp, priceList = [], titleList = [], percentageHTML = "", remainingAmountHTML = "", total_price = 0;
  let cartTotalValue = window.cartItemsData.cartTotal

  gwpList.forEach(function(promotion) {
    if(!promotion.code && promotion.minimumCartAmount) {
      priceList.push(promotion.minimumCartAmount)
      if((!promotion.maximumCartAmount || promotion.maximumCartAmount > cartTotalValue) && promotion.gifts[0] && promotion.gifts[0].title) {
        titleList.push(promotion.gifts[0].title)
      }
    }
  });

  window.cartItemsData.productData.forEach(function(variant) {
    if(variant.type != "value set") {
      total_price = total_price + variant.price;
    }
  })

  var tick =`<svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.85686 0.375H6.01504C5.83195 0.375 5.65785 0.455901 5.55015 0.59459L2.72852 4.19388L1.45053 2.56264C1.34283 2.42561 1.17052 2.34305 0.985643 2.34305H0.143822C0.0271513 2.34305 -0.041056 2.46523 0.0271513 2.55274L2.26363 5.40575C2.31647 5.47358 2.38612 5.52885 2.46681 5.56698C2.5475 5.60511 2.63691 5.625 2.72762 5.625C2.81834 5.625 2.90775 5.60511 2.98844 5.56698C3.06913 5.52885 3.13878 5.47358 3.19161 5.40575L6.97173 0.584684C7.04174 0.497178 6.97353 0.375 6.85686 0.375Z" fill="white"/>
    </svg>`;

  priceList.forEach(function(price, index) {
    if(index == 0) {
        var pricePercentage = Math.round((price * 100) / priceList[0]),
            currentPercentage = Math.round((total_price * 100) / priceList[0]),
            label= "",
            fulfilled = false;
        if(pricePercentage <= currentPercentage) {
          label = tick;
          fulfilled = true;
        } else {
          label = index + 1
        }
        if (pricePercentage >= 100) {
            percentageHTML = percentageHTML+'<span data-fulfill="'+fulfilled+'" style="left: '+pricePercentage+'%">'+label+'</span>';
        }
        if(price > total_price) {
          remainingAmountHTML = remainingAmountHTML + '<div class="price-indicatiors">Spend <span class="price">$'+(price - total_price)+'</span> more to get <span class="gift-title">'+titleList[index]+'</span>!</div>'
        } else {
          remainingAmountHTML = remainingAmountHTML + '<div class="price-indicatiors">Congratulations! You are eligible for <span class="gift-title">'+titleList[index]+'</span>!</div>'
        }
    }
  });

  document.querySelector(".price-progress-bar .remaining-amount ").innerHTML = remainingAmountHTML;

  document.querySelector(".price-progress-bar .meter [data-meter]").innerHTML = percentageHTML;

  if (Math.round((total_price * 100) / priceList[0]) >= 100) {
    document.querySelector(".price-progress-bar .meter [data-meter]").style.width = "100%";
  } else {
    document.querySelector(".price-progress-bar .meter [data-meter]").style.width = Math.round((total_price * 100) / priceList[0])+"%";
  }
}

window.promotionValidate = async function (json = []) {
    var alreadyAppliedGift = [];
    window.cart_clear = false;
    var promocode = document.querySelector('#promotion_code'), discountCodeInput = document.querySelector(".discount-code-input");
    await _getCart().then(async function(response) {

        /* store cart items data in window object */

        if(response) {
            window.cartItemsData = [];
            window.cartItemsData.productData = [];
            window.cartItemsData.productSku = [];
            window.cartItemsData.productID = [];
            window.cartItemsData.productType = [];
            window.cartItemsData.productVendor = [];
            window.cartItemsData.giftsInCart = [];
            window.cartItemsData.giftsInCartWithQuantity = [];
            window.cartItemsData.cartTotal = 0;
            response['items'].forEach(function (item) {
                if(item.properties !== null && item.properties.hasOwnProperty('_gift_product')){
                    window.cartItemsData.giftsInCart.push(item.id);
                    window.cartItemsData.giftsInCartWithQuantity.push({id: item.id, quantity: item.quantity});
                } else {
                    window.cartItemsData.productData.push({
                        id: item.id,
                        productID: item.product_id.toString(),
                        sku: item.sku,
                        vendor: item.vendor.toLowerCase(),
                        quantity: item.quantity,
                        price: (item.line_price / 100),
                        type: item.product_type.toLowerCase()
                    })
                    window.cartItemsData.productSku.push(item.sku)
                    window.cartItemsData.productID.push(item.product_id.toString())
                    window.cartItemsData.productType.push(item.product_type.toLowerCase())
                    window.cartItemsData.productVendor.push(item.vendor.toLowerCase())
                }
            });
            window.cartItemsData.cartTotal = response.total_price / 100;
        }
        var gwpList = window.promotionSettings.gwp,
            giftToAdd = json, // gift will add to cart
            giftToRemove = [], // gift will remove from cart
            conditionArray = [],
            randomGifts = [],
            clearCart = false,
            addProduct = false,
            removeProduct = false,
            appliedCode = promocode ? promocode.value.toUpperCase() : "false";

        /* Fatch products from local storage which randomly applied in cart */

        if(localStorage.getItem('randomGifts')) {
            randomGifts = JSON.parse(localStorage.getItem('randomGifts'));
        }

        /* conditions will check if cart has any non-gift products */

        if(window.cartItemsData.productData.length > 0) {
            gwpList.forEach((promotion) => {

                /* create an array of an options which is enabled in theme settings: start */

                if(promotion.minimumCartAmount != false) {
                    conditionArray.push("minimumCartAmount");
                }
                if(promotion.maximumCartAmount != false) {
                    conditionArray.push("maximumCartAmount");
                }
                if(promotion.excludeProduct != false) {
                    conditionArray.push("excludeProduct");
                }
                if(promotion.isNewCustomer != false) {
                    conditionArray.push("isNewCustomer");
                }
                if(promotion.isLoggedIn != false) {
                    conditionArray.push("isLoggedIn");
                }
                if(promotion.code != false) {
                    conditionArray.push("code");
                }

                /* create an array of an options which is enabled in theme settings : end */

                /* check conditions and create an array of an options fulfilled in cart : start */

                if(promotion.excludeProduct) {
                    if(promotion.excludeProduct.includes(",")) {
                        promotion.excludeProduct = promotion.excludeProduct.split(", ");
                    }
                }
                if(promotion.productList1) {
                    if(promotion.productList1.includes(",")) {
                        promotion.productList1 = promotion.productList1.split(", ");
                    }
                }
                if(promotion.productList2) {
                    if(promotion.productList2.includes(",")) {
                        promotion.productList2 = promotion.productList2.split(", ");
                    }
                }

                if(promotion.conditionType != false) {
                    conditionArray.push(promotion.conditionType);
                }
                if(appliedCode &&
                    appliedCode == promotion.code &&
                    promotion.code != false &&
                    !promotion.conditionArray.includes("code")) {
                    promotion.conditionArray.push("code");
                }
                if(promotion.minimumCartAmount && window.cartItemsData.cartTotal >= parseInt(promotion.minimumCartAmount) && !promotion.conditionArray.includes("minimumCartAmount")) {
                    promotion.conditionArray.push("minimumCartAmount");
                }
                if(promotion.maximumCartAmount && window.cartItemsData.cartTotal <= parseInt(promotion.maximumCartAmount) && !promotion.conditionArray.includes("maximumCartAmount")) {
                    promotion.conditionArray.push("maximumCartAmount");
                }
                if(promotion.conditionType != "any_purchase") {
                    if(!promotion.productCount) {
                        promotion.productCount = 1;
                    }
                    if(promotion.conditionType == "sku") {
                        if(compareArrays(promotion, window.cartItemsData.productSku, promotion.productCount, "sku") && !promotion.conditionArray.includes("sku")) {
                            promotion.conditionArray.push("sku");
                        }
                    }
                    if(promotion.conditionType == "type") {
                        if(compareArrays(promotion, window.cartItemsData.productType, promotion.productCount, "type") && !promotion.conditionArray.includes("type")) {
                            promotion.conditionArray.push("type");
                        }
                    }
                    if(promotion.conditionType == "product_id") {
                        if(compareArrays(promotion, window.cartItemsData.productID, promotion.productCount, "product_id") && !promotion.conditionArray.includes("product_id")) {
                            promotion.conditionArray.push("product_id");
                        }
                    }
                    if(promotion.conditionType == "vendor") {
                        if(compareArrays(promotion, window.cartItemsData.productVendor, promotion.productCount, "vendor") && !promotion.conditionArray.includes("vendor")) {
                            promotion.conditionArray.push("vendor");
                        }
                    }
                } else {
                    if(!promotion.conditionArray.includes("any_purchase")) {
                        promotion.conditionArray.push("any_purchase");
                    }
                }
                if(promotion.excludeProduct) {
                  var remaining_price = compareArrays(promotion, window.cartItemsData.productType, "", "excludeProduct");
                  if(remaining_price && !promotion.conditionArray.includes("excludeProduct")) {
                      promotion.conditionArray.push("excludeProduct");
                  }
                }
                if(promotion.isNewCustomer && window.theme.isLoggedIn && window.theme.customerSpent == 0 && !promotion.conditionArray.includes("isNewCustomer")) {
                    promotion.conditionArray.push("isNewCustomer");
                }
                if(promotion.isLoggedIn && window.theme.isLoggedIn && !promotion.conditionArray.includes("isLoggedIn")) {
                    promotion.conditionArray.push("isLoggedIn");
                }

                /* check conditions and create an array of an options fulfilled in cart : end */

                /* Compare both arrays (all options in cart and fulfilled option) */
                if(conditionArray.length == promotion.conditionArray.length) {
                    promotion.isCriteriaMeet = true;
                }

                /* create an arrays for add and remove gifts: start */

                if(promotion.isCriteriaMeet) {
                    if(promotion.code == appliedCode && appliedCode != "") {
                        invalidPromotionCode("none");
                        localStorage.setItem("promocode", promotion.code);
                        if(promocode && discountCodeInput) {
                            promocode.setAttribute('readonly', 'readonly');
                            discountCodeInput.classList.add('code-applied');
                        }
                    }
                    if(!promotion.isRandomGift) {
                        promotion.gifts.forEach((gift) => {
                            if(gift && gift.available && !window.cartItemsData.giftsInCart.includes(gift.id)) {
                                giftToAdd.push({id: gift.id, quantity: 1, properties: {'_gift_product': 'yes'}});
                            }
                        });
                    } else {

                        /* select one gift product from 3 to apply randomly */

                        var availableGifts = [];
                        promotion.gifts.forEach((gift) => { // create available list of gift product
                            if(gift && gift.available) {
                                availableGifts.push(gift);
                            }
                        });

                        // collect all randomly applied gift products
                        alreadyAppliedGift = availableGifts.filter(value => randomGifts.includes(value.id));

                        if(availableGifts.length > 0 && alreadyAppliedGift.length == 0) { // check gift product is already applied to the cart or not
                            var random_number = availableGifts.length > 1 ? Math.floor(Math.random() * availableGifts.length) : 0;
                            availableGifts.forEach((gift, index) => {
                                if(random_number == index) {
                                    if(!window.cartItemsData.giftsInCart.includes(gift.id)) { // if gift item is not added to cart
                                        giftToAdd.push({id: gift.id, quantity: 1, properties: {'_gift_product': 'yes'}});
                                        randomGifts.push(gift.id);
                                        localStorage.setItem("randomGifts", JSON.stringify(randomGifts));
                                    }
                                } else {
                                    if(gift != false && window.cartItemsData.giftsInCart.includes(gift.id)) { // if gift item is already added to cart
                                        giftToRemove[gift.id] = 0;
                                    }
                                }
                            });
                        }
                    }
                } else {

                    if(promotion.code == appliedCode && appliedCode != "") { // promotion code is valid but not fulfill requirement
                        invalidPromotionCode("block");
                    }
                    promotion.gifts.forEach((gift) => {
                        // remove rendomly added gift
                        if(randomGifts.includes(gift.id)) {
                            var index = randomGifts.indexOf(gift.id)
                            randomGifts.splice(index, 1);
                            localStorage.setItem("randomGifts", JSON.stringify(randomGifts));
                        }
                        if(gift != false && window.cartItemsData.giftsInCart.includes(gift.id)) {
                            giftToRemove[gift.id] = 0;

                            // remove promotion code and hide error
                            if(promotion.code) {
                                if(promocode && discountCodeInput) {
                                    localStorage.removeItem("promocode");
                                    promocode.removeAttribute('readonly');
                                    discountCodeInput.classList.remove('code-applied');
                                    window.clearCodeStack();
                                }
                                invalidPromotionCode("none");
                            }
                        }
                    });
                }

                /* create an arrays for add and remove gifts: end */
                conditionArray = [];
                promotion.isCriteriaMeet = false;
                promotion.conditionArray = [];
            });

            /* Add gifts to the cart */

            if(giftToAdd.length > 0) {
                addProduct = await _addGiftProduct(giftToAdd);
            }

            /* Remove gifts from the cart */

            if(Object.keys(giftToRemove).length != 0) {
                removeProduct = await _removeGiftProduct(giftToRemove)
            }

            /* reload cart when gift add/remove */
            document.dispatchEvent(new CustomEvent('cart:rerender'));

            if(removeProduct || addProduct) {
                return true;
            } else {
                return false;
            }
        } else {

            /* If cart has not include any main product all gift removed from cart */

            clearCart = await _clearCart();
            if(clearCart.items.length == 0) {
                localStorage.removeItem("randomGifts");
                window.clearCodeStack();
                document.dispatchEvent(new CustomEvent('cart:rerender'));
                return true;
            }
        }
    });
}

/* add promotion code on page load */
if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
  var promoCode = localStorage.getItem("promocode"), promocode_input = document.querySelector("#promotion_code");
  if(promoCode != null && promocode_input && window.discount.includes(promoCode)){
    if(promocode_input) promocode_input.value = promoCode;
  } else {
    if (promocode_input) promocode_input.value = "";
  }
  window.promotionValidate();
}
